module.exports = __webpack_public_path__ + "static/media/SWSCRC1-24.e53ec372.mp3";